<template>
    <v-app>
        <Header />
        <div class="body-home" v-if="['home'].includes($route.name)">
          <slot />
        </div>
        <div class="body-wrapper is-fullheight" v-if="!['home'].includes($route.name)">
          <div class="nav-column">
            <SideNav />
          </div>
          <div class="body-column">
            <div>
              <slot />
            </div>
          </div>
        </div>
        <Footer />
    </v-app>
</template>
<script>
import Header from "../components/Header.vue";
import SideNav from "../components/SideNav.vue";
import Footer from "../components/Footer.vue";

export default {
  name: "default",
  components: {
    Header,
    SideNav,
    Footer,
  },
};
</script>

<style>
#app .nav-column {
  display: none;
}
#app .body-column {
  left: 0 !important;
}
</style>

<style scoped>
.body-wrapper {
  /* margin-top: 77px; */
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.nav-column {
  background: #ddd;
  position: absolute;
  top: 87px;
  bottom: 76px;
  width: 210px;
  overflow: auto;
  scroll-behavior: smooth;
}
.body-column {
  position: absolute;
  top: 87px;
  bottom: 76px;
  left: 210px;
  right: 0;
  overflow: auto;
  scroll-behavior: smooth;
  /* background: #000;
  color: #fff; */
}

.body-home {
  position: absolute;
  top: 86px;
  bottom: 76px;
  left: 0;
  right: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.nav-columnx {
  top: 100px;
  left: 10px;
  width: 200px;
  bottom: auto;
  background: none;
  z-index: 100;
}
</style>